// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecentActivities_ra__0BQbB {
  display: flex;
  flex-direction: column;
}
.RecentActivities_ra__main__lV7Bi {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-white);
  padding: 3rem 2rem;
  height: 48rem;
  overflow-y: scroll;
}
.RecentActivities_ra__main__lV7Bi::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-white);
  border-radius: 0 3rem 3rem 0;
}
.RecentActivities_ra__main__lV7Bi::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 3rem;
}
.RecentActivities_ra__content__DYy9F {
  width: 100%;
}
.RecentActivities_ra__content__DYy9F > :not(:last-child) {
  margin-bottom: 2rem;
}
.RecentActivities_ra__content_list__ZdCd0 {
  display: grid;
  grid-template-columns: 3rem 1fr 0.3fr;
  gap: 2rem;
  align-items: center;
}
.RecentActivities_ra__content_icon__-nq-p {
  content: "";
  background-color: var(--color-green);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 1.5rem;
  justify-self: center;
}

.RecentActivities_debit__2yOvE {
  background-color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Wallet/RecentActivities.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,sBAAA;AACD;AACC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AACF;AACE;EACC,WAAA;EACA,oCAAA;EACA,4BAAA;AACH;AAEE;EACC,mCAAA;EACA,mBAAA;AAAH;AAIC;EACC,WAAA;AAFF;AAGE;EACC,mBAAA;AADH;AAIE;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;AAFH;AAOE;EACC,WAAA;EACA,oCAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,oBAAA;AALH;;AAUA;EACC,oCAAA;AAPD","sourcesContent":[".ra {\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t&__main {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbackground-color: var(--color-white);\n\t\tpadding: 3rem 2rem;\n\t\theight: 48rem;\n\t\toverflow-y: scroll;\n\n\t\t&::-webkit-scrollbar {\n\t\t\twidth: 1rem;\n\t\t\tbackground-color: var(--color-white);\n\t\t\tborder-radius: 0 3rem 3rem 0;\n\t\t}\n\n\t\t&::-webkit-scrollbar-thumb {\n\t\t\tbackground-color: var(--color-grey);\n\t\t\tborder-radius: 3rem;\n\t\t}\n\t}\n\n\t&__content {\n\t\twidth: 100%;\n\t\t& > :not(:last-child) {\n\t\t\tmargin-bottom: 2rem;\n\t\t}\n\n\t\t&_list {\n\t\t\tdisplay: grid;\n\t\t\tgrid-template-columns: 3rem 1fr 0.3fr;\n\t\t\tgap: 2rem;\n\t\t\talign-items: center;\n\t\t}\n\t\t&_details {\n\t\t}\n\n\t\t&_icon {\n\t\t\tcontent: '';\n\t\t\tbackground-color: var(--color-green);\n\t\t\twidth: 1.5rem;\n\t\t\theight: 1.5rem;\n\t\t\tborder-radius: 1.5rem;\n\t\t\tjustify-self: center;\n\t\t}\n\t}\n}\n\n.debit {\n\tbackground-color: var(--color-error);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ra": `RecentActivities_ra__0BQbB`,
	"ra__main": `RecentActivities_ra__main__lV7Bi`,
	"ra__content": `RecentActivities_ra__content__DYy9F`,
	"ra__content_list": `RecentActivities_ra__content_list__ZdCd0`,
	"ra__content_icon": `RecentActivities_ra__content_icon__-nq-p`,
	"debit": `RecentActivities_debit__2yOvE`
};
export default ___CSS_LOADER_EXPORT___;
